// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2JJGu","label":"SetPasswdForm_label__3Qy3l"};